<template>
    <div id="app">
        <template>
            <b-navbar toggleable="md" variant="primary">
                <b-navbar-toggle target="navbar-toggle-collapse"></b-navbar-toggle>

                <b-navbar-brand>
                    <img src="./assets/img/logo.jpg" alt="" @click="scrollToElement('home')" />
                </b-navbar-brand>

                <b-collapse id="navbar-toggle-collapse" is-nav>
                    <b-navbar-nav class="align-items-center">
                        <b-nav-item @click="scrollToElement('home')" to="/#">Accueil</b-nav-item>
                        <b-nav-item @click="scrollToElement('programme')" to="/#">Programme</b-nav-item>
                        <b-nav-item @click="scrollToElement('intervenants')" to="/#">Intervenants</b-nav-item>
                        <b-nav-item @click="scrollToElement('permis-tronconneuse')" to="/#">Le Permis Tronçonneuse</b-nav-item>
                        <b-nav-item @click="scrollToElement('acces')" to="/#">Accès & Infos</b-nav-item>
                    </b-navbar-nav>
                    <ul class="navbar-nav ml-auto align-items-center">
                        <li class="nav-item">
                            <a href="https://forms.gle/GoLukErHRdyYDvs36" target="_blank" class="btn btn-primary btn-inscription">
                                <span>S'inscrire</span>
                                <i class="fa-solid fa-arrow-up-right-from-square ml-2"></i
                            ></a>
                        </li>
                    </ul>
                </b-collapse>
            </b-navbar>
            <router-view ref="view "></router-view>

            <footer class="px-5">
                <div class="row no-gutters mx-0 my-3">
                    <div class="col">Créé par INNOV'events Dijon ©{{ new Date().getFullYear() }}</div>
                </div>
            </footer>
        </template>
    </div>
</template>

<script>
export default {
    methods: {
        scrollToElement(target) {
            let element = this.$refs["view "].$refs[target];
            const y = element.$el.getBoundingClientRect().top + window.pageYOffset - 57;
            window.scrollTo({ top: y, behavior: "smooth" });
        },
    },
};
</script>
